import { render, staticRenderFns } from "./SiteModalMessage.vue?vue&type=template&id=452405f1&scoped=true"
import script from "./SiteModalMessage.vue?vue&type=script&lang=ts"
export * from "./SiteModalMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452405f1",
  null
  
)

export default component.exports